const MenuStickyLeftReducers = (state = false, action) => {
  switch (action.type) {
    case "stickyLeft":
      return !state;
    default:
      return state;
  }
};
export default MenuStickyLeftReducers;
